export default __webpack_public_path__ + "static/media/claro.c3aabb7d.JPG";